import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_sanitizer as t } from "./html/sanitizer.js";
import { require_sanitizer as n } from "./url/sanitizer.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0_canvas@3.2.0_/node_modules/@intercom/intercom-sanitizer/dist/index.js
var r = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "sanitizeHtml", {
		enumerable: !0,
		get: function() {
			return r.sanitizeHtml;
		}
	}), Object.defineProperty(e, "sanitizeUrl", {
		enumerable: !0,
		get: function() {
			return i.sanitizeUrl;
		}
	});
	var r = t(), i = n();
}));
//#endregion
export default r();
export { r as require_dist };
